import React, { useState, useEffect } from "react";
import { Card, Col, FormGroup, Label } from "reactstrap";
import { toast } from "react-toastify";
import { Btn } from "../../../../AbstractElements";
import api from "../../../../services/api";
import { baseUrl } from "../../../../Utils/Baseurl/Baseurl";
import { jwtDecode } from "jwt-decode";
import { JwtPayload } from "jsonwebtoken";
interface CustomJwtPayload extends JwtPayload {
  id: string;
}

interface AssignedDate {
  id: number;
  dates: string;
}

export default function Appointment({ onBookingSuccess }: { onBookingSuccess?: () => void }) {
    const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [assignedDates, setAssignedDates] = useState<AssignedDate[]>([]);
  const [tokenCount, setTokenCount] = useState<number>(0);
  const [totaltoken, setTotaltoken] = useState("");

  useEffect(() => {
    fetchAssignedDates();
  }, []);

  const fetchAssignedDates = async () => {
    try {
        const response = await api.get(`${baseUrl}assignedDates/getAllDates`);
        const sortedDates = response.data.sort((a: AssignedDate, b: AssignedDate) => 
            new Date(a.dates).getTime() - new Date(b.dates).getTime()
        );

        const now = new Date();
        const todayNoon = new Date();
        todayNoon.setHours(12, 0, 0, 0); // Set time to 12:00 PM

        const upcomingDate = sortedDates.find((date: AssignedDate) => {
          const assignedDate = new Date(date.dates);
          return assignedDate.toDateString() === now.toDateString() || assignedDate > now;
      });
      

        if (upcomingDate) {
            setSelectedDate(upcomingDate.dates);
        } else {
            toast.error("No upcoming dates available.");
        }

        setAssignedDates(sortedDates);
    } catch (error) {
        toast.error("Failed to fetch assigned dates.");
    }
};


  useEffect(() => {
    if (selectedDate) {
      fetchTokenCount(selectedDate);
    }
  }, [selectedDate]);

  const fetchTokenCount = async (date: string) => {
    try {
      const formattedDate = new Date(date).toISOString().split("T")[0]; // Convert string to Date first
  
      const response = await api.get(`${baseUrl}tokenregistration/tokenCount`, {
        params: { appointmentdate: formattedDate }, // Use formattedDate
      });
  
      setTokenCount(response.data.count);
      setTotaltoken(response.data.totalbookings);
    } catch (error) {
      toast.error("Failed to fetch token count.");
    }
  };
  

  const handleTokenBooking = async () => {
    if (!selectedDate) {
      toast.error("Please select a date!");
      return;
    }
  
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("User is not logged in!");
      return;
    }
  
    try {
      const decoded = jwtDecode<CustomJwtPayload>(token);
      const userId = decoded.id;
  
      if (!userId) {
        toast.error("Invalid token, user ID not found!");
        return;
      }
  
      const response = await api.get(`${baseUrl}tokenregistration/tokenCount`, {
        params: { appointmentdate: selectedDate },
      });
  
      const lastTokenNo = response.data.lastTokenNo ? response.data.lastTokenNo + 1 : 1;
      const maxTokens = parseInt(totaltoken) + 1; // Ensure numeric conversion
  
      const data = {
        appointmentdate: selectedDate,
        type: "REP",
        userId: userId,
        tokenno: maxTokens,
        tokenCount:tokenCount+1
      };
  
      const bookingResponse = await api.post(`${baseUrl}tokenregistration/createtoken`, data);
      toast.success(bookingResponse.data.message);
  console.log(bookingResponse,'bookingResponse');
      fetchTokenCount(selectedDate); // Refresh token count
      onBookingSuccess?.(); // Trigger re-fetch in BookedTokens
    } catch (error: any) {
      toast.error("Error booking token: " + (error.response?.data?.message || error.message));
    }
  };
  
  return (
    <Col>
    <Card>
      <div className="mt-5 mx-5 my-5 mb-0">
    <FormGroup className="d-flex justify-content-between">
      <div>
        <Label>Next Booking Date</Label>
        <p style={{color:"green"}} ><strong>{selectedDate ? new Date(selectedDate).toLocaleDateString("en-GB") : "No upcoming date"}</strong></p>
      </div>
      <div>
        <Label>Total Bookings</Label>
        <p>{tokenCount}</p>
      </div>
      <div>
        <Btn color="primary" className="w-auto" onClick={handleTokenBooking}>
          Book Token
        </Btn>
      </div>
    </FormGroup>
    </div>
    </Card></Col>
  );
}
